const odsList = [
  "274949",
  "0000001",
  "1122333",
  "1548616",
  "1573849",
  "1580205",
  "1637265",
  "1640296",
  "1760546",
  "1770470",
  "1784878",
  "1838386",
  "1900281",
  "1907406",
  "1927628",
  "1933293",
  "1941639",
  "1941640",
  "1952524",
  "1996758",
  "2002967",
  "2021837",
  "2099794",
  "2349865",
  "2390704",
  "2398494",
  "2409477",
  "2451960",
  "2457718",
  "2519648",
  "2521774",
  "2522282",
  "2524956",
  "2528323",
  "2528658",
  "2528823",
  "2530419",
  "2532197",
  "2534514",
  "2535619",
  "2538592",
  "2541978",
  "2542183",
  "2542199",
  "2543214",
  "2544733",
  "2544944",
  "2550202",
  "2571297",
  "2571678",
  "2572255",
  "2572532",
  "2572694",
  "2572749",
  "2573229",
  "2573248",
  "2573771",
  "2573993",
  "2574949",
  "2574974",
  "2575890",
  "2576802",
  "2577215",
  "2579309",
  "2580306",
  "2581998",
  "2582066",
  "2583235",
  "2583925",
  "2584269",
  "2584544",
  "2585263",
  "2585720",
  "2585744",
  "2585871",
  "2586293",
  "2586593",
  "2586922",
  "2586923",
  "2587196",
  "2588287",
  "2588500",
  "2589010",
  "2589177",
  "2589474",
  "2589924",
  "2591123",
  "2591389",
  "2592140",
  "4065296",
  "4067924",
  "4068353",
  "9090761",
  "9097596",
  "9107164",
  "9132260",
  "9142230",
  "9159543",
  "9185991",
  "9193955",
  "9205098",
  "9210506",
  "9229542",
  "9267993",
  "9271708",
  "9281451",
  "9311083",
  "9318917",
  "9325107",
  "9333803",
  "9349293",
  "9351306",
  "9360462",
  "9364139",
  "9370113",
  "9376930",
  "9418862",
  "9445672",
  "9534273",
  "9538886",
  "9539101",
  "9553046",
  "9562101",
  "9597311",
  "9583224",
  "9648984",
  "9657364",
  "9770763",
  "9746287",
  "9770810",
  "9795105",
  "9790236",
  "9812694",
  "9819811",
  "9828414",
  "9845189",
  "9867354",
  "9858639",
  "9867322",
  "9898107",
  "9899609",
  "9905738",
  "9909368",
  "9919016",
  "9938933",
  "9941008",
  "9951702",
  "9952540",
  "9957871",
  "9963250",
  "90045729",
  "90068611",
  "90070608",
  "90095610",
  "90096676",
  "90099025",
  "90108802",
  "90110130",
  "90122814",
  "90130072",
  "90135662",
  "90137613",
  "90151578",
  "90181677",
  "90193233",
  "90198792",
  "90239412",
  "90255158",
  "90282757",
  "90296460",
  "90300172",
  "90306878",
  "90316974",
  "90326080",
  "90366920",
  "90402978",
  "90412707",
  "90457805",
  "90465415",
  "90468932",
  "90489044",
  "90494598",
  "90497528",
  "90516853",
  "90561329",
  "90561484",
  "90564833",
  "90572120",
  "90572675",
  "90577776",
  "90590332",
  "90594512",
  "90598027",
  "90598269",
  "90598547",
  "90598839",
  "90599359",
  "90599925",
  "90600753",
  "90613574",
  "90631195",
  "90631624",
  "90632457",
  "90642059",
  "90645556",
  "90658150",
  "90661059",
  "90674876",
  "90710212",
  "90724945",
  "90725797",
  "90727450",
  "90741349",
  "90752079",
  "90782994",
  "90785205",
  "90786101",
  "90805168",
  "90809464",
  "90810082",
  "90835099",
  "90852679",
  "90861255",
  "90866033",
  "90882815",
  "90883560",
  "90917376",
  "90928027",
  "90928445",
  "90928905",
  "90938757",
  "90963635",
  "90976253",
  "90978405",
  "90994396",
  "91003314",
  "91005620",
  "91031945 - A"
];

const odsListStaging = ["1122333", "4455666", "7788999"];

export { odsList, odsListStaging };
